import { render, staticRenderFns } from "./NumberDisplay.vue?vue&type=template&id=04127d0b&"
import script from "./NumberDisplay.vue?vue&type=script&lang=ts&"
export * from "./NumberDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./NumberDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports